export default {
    listQueryId: "searchPortfoliosWithDetails",
    responseFieldName: "searchPortfolios",
    queryParams: {
        must: [],
        filter: [],
        should: [],
        must_not: [],
    },
    form: {
        dateField: 'approvalDate',
        dateFrom: null,
        dateTo: null,
        portfolio: [],
    },
    formConfig: {
        dateField: {
            options: [
                {
                    key: "applicationReceived",
                    label: "Application Received",
                },
                {
                    key: "approvalDate",
                    label: "Approval Date",
                },
                {
                    key: "dateFirstProcessing",
                    label: "Processing Live Date",
                },
                {
                    key: "dateSubmitted",
                    label: "Submitted To Underwriting",
                },
            ],
        },
        portfolio: {
            config: {
                label: "Portfolios",
                pageMode: "edit",
                name: "portfolio",
                subscribe: {
                    onCreate: {
                        model: "Portfolio",
                        inputField: "portfolios",
                        target: "Portfolio",
                    },
                    onDelete: {
                        model: "Portfolio",
                        inputField: "portfolios",
                        target: "Portfolio",
                    },
                },
                list: {
                    hideNewRecordButton: true,
                    hideListHeader: true,
                    editPath: "portfolios",
                    objectName: "portfolio",
                    pageTitle: "Portfolios",
                    pageIcon: "store",
                    listQueryId: "searchPortfoliosWithDetails",
                    responseFieldName: "searchPortfolios",
                    createMutationId: "createPortfolio",
                    deleteQueryId: "deletePortfolio",
                    deleteQueryIdField: "id",
                    deleteMessageTitle: "Are you sure you want to remove {objectName} from this Report?",
                    deleteMessageText: "",
                    linkRows: false,
                    skipCardLayout: true,
                    itemActions: [
                        {
                            class: "md-just-icon md-simple md-warning",
                            classAdded: "item.added? 'check_circle' : 'md-warning'",
                            icon: "post_add",
                            iconAdded: "check_circle",
                            click: "handleAddReportPortfolio",
                        },
                    ],
                    columns: {
                        name: { label: "Name", sortable: true },
                        createdAt: { label: "Created", sortable: true, dateFilter: true },
                    },
                    perPageOptions: [5, 10, 20, 25, 50],
                    defaults: {
                        sort: "createdAt",
                        sortDir: "desc",
                        perPage: 10,
                    },
                    fuseSearch: null,
                    relateRecordInput: {
                        // productId: null,
                        // portfolioId: null,
                        name: null,
                        description: null,
                    },
                    relateRecordInputField: null,
                    // relateRecordInputField: "portfolioId",
                    relateRecordRouteField: "id",
                    // relateRecordRouteField: "portfolioId",
                },
            },
        },
    },
};